document.addEventListener('DOMContentLoaded', function () {
  var page = document.querySelector('.collection-page[data-default-filter]');
  if (!page) {
    return;
  }

  page.querySelectorAll('[data-women-comparison-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var group = button.closest('[data-women-comparison-group]');
      var panel = group.querySelector('.collection-women-comparison__group-panel');
      var isOpen = group.classList.toggle('is-open');

      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.hidden = !isOpen;
    });
  });

  var cards = page.querySelectorAll('.collection-product-card');
  var audienceSections = page.querySelectorAll('[data-audience-section], [data-hide-audience]');
  var defaultFilter = page.getAttribute('data-default-filter') || 'all';

  if (!cards.length && !audienceSections.length) {
    return;
  }

  var applyAudienceView = function (filter) {
    cards.forEach(function (card) {
      var audience = card.getAttribute('data-audience');
      var show = filter === 'all' || audience === filter;

      card.hidden = !show;
    });

    audienceSections.forEach(function (section) {
      var sectionAudience = section.getAttribute('data-audience-section');
      var hideAudience = section.getAttribute('data-hide-audience');
      var isHidden = false;

      if (hideAudience) {
        isHidden = filter === hideAudience;
      } else if (sectionAudience) {
        isHidden = sectionAudience !== filter;
      }

      section.hidden = isHidden;
    });

    window.dispatchEvent(new Event('resize'));
  };

  applyAudienceView(defaultFilter);
});
